import React from 'react';
import { Global } from '@emotion/react';

import { cn } from '@lyearn/style';
import { mergeOverrides } from '@lyearn/ui';
import { Stack } from '@lyearn/ui';
import { DialogComponent } from '@/components/DialogComponent';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
import Tabs from '@/components/Tabs';

import * as ContentList from '../ContentList';
import Body from './Body';
import { filterModalStyles } from './styles';
import { ContentListModalProps } from './types';

const MODAL_CLASSES: React.ComponentProps<typeof DialogComponent>['classes'] = {
  paper: 'h-full',
};

function ContentListModalMain<T>(props: ContentListModalProps<T>) {
  const {
    items,
    children,
    className,
    header,
    searchBar,
    tabs,
    fetchMore,
    sortComponent,
    classes,
    showCloseBtn = true,
    variant = undefined,
    footer,
    ...rest
  } = props;

  const mergedOverrides = mergeOverrides(MODAL_CLASSES, classes);
  //TODO: check if can use suggested comp https://github.com/Lyearn/frontend-universe/pull/1585#discussion_r849763038
  const modalHeader = React.useMemo(() => {
    return {
      ...header,
      children: (
        <>
          {header.children}
          {tabs?.tabs && tabs.tabs.length > 1 ? (
            <Stack className={classes?.tabContainer ?? 'mx-12 mb-24'}>
              <Tabs {...tabs} />
            </Stack>
          ) : null}
          {searchBar ? (
            <ContentList.Search
              key={tabs?.value}
              className={searchBar.className}
              placeholder={searchBar.placeholder}
              selectedCount={searchBar.selectedCount}
              shape="square"
              size={searchBar.size}
              value={searchBar.value}
              onChange={searchBar.onChange}
            />
          ) : null}
          {sortComponent ? sortComponent : null}
        </>
      ),
    };
  }, [classes?.tabContainer, header, searchBar, sortComponent, tabs]);

  const modalVariant = tabs?.tabs.length ? ModalVariant.ExtraWide : ModalVariant.FullHeight;

  return (
    <Modal
      classes={mergedOverrides}
      footer={footer}
      header={modalHeader}
      showCloseBtn={showCloseBtn}
      variant={variant || modalVariant}
      {...rest}>
      <ContentList.Provider
        className={cn('flex flex-1 flex-col', className)}
        fetchMore={fetchMore}
        items={items}>
        {/* consult @harshit bro about this injection */}
        <Global styles={filterModalStyles} />
        {children}
      </ContentList.Provider>
    </Modal>
  );
}

export { Body, ContentListModalMain as Main };
